// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-1v0cj"};